/**
 * One key family for everything that reads the consignee master, so an import
 * from the wizard invalidates the Master page's table and an open draft's
 * NPWP lookup alike. Kept in its own module so the live-sync helper can use it
 * without importing the HTTP layer.
 */
export const consigneeKeys = {
  all: ['master', 'consignees'] as const,
  list: (params: Record<string, unknown>) => ['master', 'consignees', 'list', params] as const,
  /** Super-admin cross-PPJK list. Under `all`, so any consignee write refreshes it too. */
  global: (params: Record<string, unknown>) => ['master', 'consignees', 'global', params] as const,
  lookup: (npwp: string) => ['master', 'consignees', 'lookup', npwp] as const,
  search: (query: string) => ['master', 'consignees', 'search', query] as const,
};
